import React from "react";
import { useMediaQuery } from "react-responsive";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { convertTo12HourFormat, handleDateSetUp } from "../../../../../../helpers/helpers";


function AuctionTimeAndLocation({ auctioDetailsData, loading }) {
  const isLaptop = useMediaQuery({ query: "(max-width: 870px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 600px)" });

  const rerenderSpanTag = (label, value) => {
    return (
      <span>
        <p>{label}</p>
        <p>{value}</p>
      </span>
    );
  };

  return (
    <div
      className={`catelogData-value p-1 ${
        isTablet ? "grid-column-3" :isLaptop?"grid-2": "grid-3"
      }`}
      style={{ gap: "1rem" }}
    >
      {loading ? (
        <>
          <Skeleton height={30} width={`100%`} />
          <Skeleton height={30} width={`100%`} />
          <Skeleton height={30} width={`100%`} />
          <Skeleton height={30} width={`100%`} />
          <Skeleton height={30} width={`100%`} />
          <Skeleton height={30} width={`100%`} />
        </>
      ) : (
        <>
          {rerenderSpanTag(
            "Auction Date",
            `${handleDateSetUp(
              auctioDetailsData?.auctionSchedule?.startDate
            )}`
          )}

          {rerenderSpanTag(
            "Auction Time",
            `${convertTo12HourFormat(
              auctioDetailsData?.auctionSchedule?.startingTime
            )} - ${convertTo12HourFormat(
              auctioDetailsData?.auctionSchedule?.endingTime
            )}`
          )}

          {rerenderSpanTag(
            "EMD End Time & Date",
            `${convertTo12HourFormat(
              auctioDetailsData?.EMDSchedule?.lastTime
            )} & ${handleDateSetUp(auctioDetailsData?.EMDSchedule?.lastDate)}`
          )}

          {rerenderSpanTag(
            "Inspection Start Time",
            `${convertTo12HourFormat(
              auctioDetailsData?.inspectionSchedule?.startingTime
            )}`
          )}

          {rerenderSpanTag(
            "Inspection End Time & Date",
            `${convertTo12HourFormat(
              auctioDetailsData?.inspectionSchedule?.endingTime
            )} - ${handleDateSetUp(
              auctioDetailsData?.inspectionSchedule?.endDate
            )}`
          )}

          {rerenderSpanTag(
            "Location",
            auctioDetailsData?.inspectionSchedule?.inspectionLocation
          )}
        </>
      )}
    </div>
  );
}

export default AuctionTimeAndLocation;

